import styled, { css } from "styled-components";

import { media } from "@src/common/styles/mixins";
import BaseModalWrapper from "@src/modules/shared/components/Modal/BaseModalWrapper";

const DefaultModalWrapper = styled(BaseModalWrapper)<{
  adjustWidthToContent?: boolean;
  allowOverflow?: boolean;
}>`
  display: flex;
  flex-direction: column;
  margin: auto;
  overflow: ${(p) => (!!p.allowOverflow ? "visible" : "hidden")};
  ${(p) =>
    !p.adjustWidthToContent &&
    css`
      width: 100%;
      max-width: 511px;
    `}

  ${media.down("MOBILE")`
    min-height: 100%;
    height: 100%;
    border-radius: 0;
    overflow-y: auto;
  `}
`;

export default DefaultModalWrapper;
